export function asSliderValue(value: number | number[]) {
  return Array.isArray(value) ? value[0] : value;
}

export function toRgba(hexColor: string, opacity: number) {
  const normalizedColor = hexColor.replace('#', '');

  if (!/^[0-9a-f]{6}$/i.test(normalizedColor)) {
    return hexColor;
  }

  const red = parseInt(normalizedColor.slice(0, 2), 16);
  const green = parseInt(normalizedColor.slice(2, 4), 16);
  const blue = parseInt(normalizedColor.slice(4, 6), 16);

  return `rgba(${red}, ${green}, ${blue}, ${opacity / 100})`;
}
